
const algoliaClientId = '29PS8V2VYH',
  algoliaSearchKey = 'f6aa788c5dbc05bdfa3a73e7e9574845'

export { algoliaClientId, algoliaSearchKey }
